import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';
import Zoom from '@mui/material/Zoom';
import { MdClose } from 'react-icons/md';
import FramiIconButton from './FramiIconButton';


const FramiTooltip = styled(({
    className,
    tooltipStyle,
    openTooltip,
    closeButton,
    onClose,
    ...props
}) => {
    const [open, setOpen] = React.useState(!!openTooltip);

    React.useEffect(() => {
        setOpen(!!openTooltip);
    }, [openTooltip]);

    const handleClose = () => {
        onClose && onClose();
        setOpen(false);
    }

    return (
        <Tooltip
            {...props}
            classes={{ popper: className }}
            enterTouchDelay={0}
            open={open}
            TransitionComponent={Zoom}
            TransitionProps={{
                timeout: {
                    appear: 0,
                    enter: 0,
                    exit: 500,
                }
            }}
            title={props.title ? (
                <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                    {props.title}
                    {closeButton && (
                        <FramiIconButton
                            onClick={handleClose}
                            style={{ cursor: 'pointer', opacity: 0.6 }}
                            icon={<MdClose size={18} />}
                            dataCy="close-tooltip"
                        />
                    )}
                </div>
            ) : ''}
        />
    );
})(
    ({ theme, tooltipStyle }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: tooltipStyle?.backgroundColor || '#F3F4F6',
            color: tooltipStyle?.color || '#6B7280',
            boxShadow: tooltipStyle?.boxShadow ||
                '9px 9px 27px rgba(0, 0, 0, 0.32), inset 0.2px 0.2px 0px rgba(255, 255, 255, 0.16), inset -0.2px -0.2px 0px rgba(0, 0, 0, 0.16)',
            fontSize: tooltipStyle?.fontSize || '14px',
            fontWeight: tooltipStyle?.fontWeight || '400',
            padding: tooltipStyle?.padding || '14px',
            border: tooltipStyle?.border || '1px solid #E5E7EB',
            borderRadius: tooltipStyle?.borderRadius || '8px',
            userSelect: 'none',
            textAlign: tooltipStyle?.textAlign || 'justify',
            marginTop: '0 !important',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: tooltipStyle?.backgroundColor || '#F3F4F6',
            left: '10px !important',
        },
    })
);

export default FramiTooltip;
